import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-admin-bottom-navigation',
  templateUrl: './hotel-admin-bottom-navigation.component.html',
  styleUrls: ['./hotel-admin-bottom-navigation.component.css']
})
export class HotelAdminBottomNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
